export default {
  trainingCourseDetail_image_text: '图文',
  trainingCourseDetail_blend: '混合',
  trainingCourseDetail_games: '游戏',
  trainingCourseDetail_vedio: '视频',
  trainingCourseDetail_audio: '音频',
  trainingCourseDetail_e_books: '电子书',
  trainingCourseDetail_not_completed: '暂未完成本课件的全部打卡验证',
  trainingCourseDetail_continue_punch: '请继续学习完成打卡',
  trainingCourseDetail_clock_progress: '打卡进度',
  trainingCourseDetail_continue_learn: '继续学习',
  trainingCourseDetail_learned_rules01: '已学条件：学习完整内容并超过{ruleValue}分钟',
  trainingCourseDetail_learned_rules02: '注：含考试的课件，未学满{ruleValue}分钟，考试通过也无法标记已学，需学满{ruleValue}分钟后再重新考试。',
  trainingCourseDetail_exit_Course: '退出学习',
  trainingCourseDetail_book_title_mark1: '《',
  trainingCourseDetail_book_title_mark2: '》',
  trainingCourseDetail_Learn_now: '立即学习',
  trainingCourseDetail_Learn_precess: "已学习{processValue}%",
}
